import appBuild from '@/generated/app-build.json';

export interface AppVersionInfo {
  version: string;
  build: string;
  builtAt?: string;
}

export const RUNNING_BUILD_ID: string = appBuild.build;

export function isNewerBuild(
  remoteBuild: string,
  runningBuild: string = RUNNING_BUILD_ID
): boolean {
  if (!remoteBuild || !runningBuild) return false;
  return remoteBuild !== runningBuild;
}

export async function fetchRemoteVersion(): Promise<AppVersionInfo | null> {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return null;
    return (await response.json()) as AppVersionInfo;
  } catch {
    return null;
  }
}

export async function checkForAppUpdate(): Promise<boolean> {
  const remote = await fetchRemoteVersion();
  if (!remote?.build) return false;
  return isNewerBuild(remote.build);
}
